// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15VUE","colMin":"styles_colMin__1WoEv"};